import { getDatabases } from '../../../modules/databases/databases.repository';
import { Database } from '../../../modules/databases/types';

export const getDatabasesUseCase = (): Promise<Database[]> => {
  return getDatabases();
};
